import { FaireOncall } from "@faire/types-observability-api/faire/logging/FaireOncall";
import { FairePillar } from "@faire/types-observability-api/faire/logging/FairePillar";
import { FairePod } from "@faire/types-observability-api/faire/logging/FairePod";
import {
  getOncallForFairePod,
  getPillarForFairePod,
} from "@faire/types-observability-api/faire/logging/FairePodExtensions";
import type { ProductArea } from "@faire/types-observability-api/faire/logging/ProductArea";
import { getPodForProductArea } from "@faire/types-observability-api/faire/logging/ProductAreaExtensions";

export type Attribution = {
  productArea: keyof typeof ProductArea;
  pod: keyof typeof FairePod;
  pillar: keyof typeof FairePillar;
  oncall: keyof typeof FaireOncall;
};

export const getAttribution = (
  productArea: keyof typeof ProductArea
): Attribution => {
  const pod: keyof typeof FairePod =
    getPodForProductArea(productArea) ?? "FAIRE_POD_UNASSIGNED";
  const pillar: keyof typeof FairePillar =
    getPillarForFairePod(pod) ?? "FAIRE_PILLAR_UNASSIGNED";
  const oncall: keyof typeof FaireOncall =
    getOncallForFairePod(pod) ?? "FAIRE_ONCALL_UNASSIGNED";
  return { productArea, pod, pillar, oncall };
};
